import auth from 'src/router/auth'
import Invoice from '../Invoice'
import NewInvoice from '../NewInvoice'
import EditInvoice from '../EditInvoice'
import DetailInvoice from '../DetailInvoice'
import InvoiceReport from '../InvoiceReport'

export default [
  // {
  //   path: '/',
  //   name: 'dashboard',
  //   component: Invoice,
  //   beforeEnter: auth.requireAuth
  // },
  {
    path: '/invoices',
    name: 'invoice',
    component: Invoice,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/invoices/create',
    name: 'create-invoice',
    component: NewInvoice,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/invoices/report',
    name: 'invoice-report',
    component: InvoiceReport,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/invoices/:id/edit',
    name: 'edit-invoice',
    component: EditInvoice,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/invoices/:id',
    name: 'detail-invoice',
    component: DetailInvoice,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/invoice/routes/index.js